import modelBaseV2 from '../model-base-v2.model';

let visitRateModel = {

  getVisitSummaryRate: function (filter) {
    let qsObj = {
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      siteGroupIDs: filter.siteGroups,
      siteIDs: filter.sites,
      UserIds: filter.users,
      UserRoles: filter.userRoles,
      locations: filter.locations,
      storeGrade: filter.storeGrades,
      bu: filter.bu
    };
    const qs = modelBaseV2.toQueryString(qsObj);
    return modelBaseV2.get('/api/schedule/visitSummaryRate?' + qs);
  },

  getVisitRateData: function (filter) {
    let qsObj = {
      fromDate: filter.fromDate,
      toDate: filter.toDate,
      siteGroupIDs: filter.siteGroups,
      siteIDs: filter.sites,
      userIds: filter.users,
      visitPlanStatus: filter.planStatus,
      PageIndex: filter.pageIndex,
      PageSize: filter.pageSize,
      UserRoles: filter.userRoles,
      locations: filter.locations,
      storeGrade: filter.storeGrades,
      bu: filter.bu
    };
    return modelBaseV2.post('/api/schedule/visitrate', {body: qsObj});
  }
}

export default visitRateModel;
